// src/api/healthcare/XoeObservationsApi.ts
// Confirmed patient observations Xoe remembers (ClickUp 14ygtkj83tv S6/S10).
// HEALTHCARE routes, never the agent host — a withdraw is a clinical write (the `XoeActionsApi.ts` rule).
// `VITE_HEALTHCARE_SERVER` already ends in `/api`.

import { ENV } from "../../config/runtimeEnv";
import { WithdrawXoeObservationResponse, XoeObservation } from "../../types/xoe/XoeMemoryTypes";
import type { UserUuid } from "../../types/identity";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

/** Active observations, newest first; `includeWithdrawn` adds the withdrawn rows. */
export const listXoeObservations = async (
	patientId: UserUuid,
	options: { includeWithdrawn?: boolean } = {}
): Promise<XoeObservation[]> => {
	const response = await http.get(
		`${API_BASE_URL}/practitioner/patients/${patientId}/xoe-observations`,
		{
			params: options.includeWithdrawn ? { include_withdrawn: 1 } : {},
		}
	);
	return response.data.data;
};

/** Idempotent; 404 on an unknown id. Any practitioner may withdraw (D5). */
export const withdrawXoeObservation = async (
	observationId: number
): Promise<WithdrawXoeObservationResponse> => {
	const response = await http.post(
		`${API_BASE_URL}/practitioner/xoe/observations/${observationId}/withdraw`,
		{}
	);
	return response.data.data;
};
